module.exports = __webpack_public_path__ + "static/media/polaroid-5.0c4f6819.png";